module.exports = __webpack_public_path__ + "static/media/Approval.4a953dfb.svg";